import { Fragment, useEffect, useState } from 'react';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { getUserAuthentication, getUserByToken, login } from '../core/_requests';
import { useLocation, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useAuth } from '../core/Auth';
import { callServices } from '../../../../common/timeLiveFunction';
import Loader from '../../../../common/Loader';

const objLoginValues = {
  emailAddress: "",
  password: ""
}

const objErrorValues = {
  isShow: false,
  message: ""
}

const { REACT_APP_TIMELIVE_API_URL, NODE_ENV, REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env;
var base_url = window.origin + '/classic/';

export function Login() {
  const [loginValues, setLoginValues] = useState<any | ''>(objLoginValues);
  const [errorValues, setErrorValues] = useState<any | ''>(objErrorValues);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowLogin, setShowLogin] = useState<any | ''>(false);
  const { saveAuth, setCurrentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("samlvalue");
    if (token) {
      loginWithSaml(Number(token));
    } else {
      getLoginDetail();
    }
  }, []);

  // useEffect(() => {
  //   getLoginDetail()
  // }, []);

  const getLoginDetail = async () => {
    if (NODE_ENV === 'development') {
      base_url = REACT_APP_TIMELIVE_API_URL as string;
    }
    try {
      const response: any = await fetch(`${base_url}api/Account/TimeLiveLoginDetail/`, {
        method: 'GET'
      });
      const json = await response.json();
      if (json != null) {
        window.location.href = json.includes("https:") ? json : `${window.origin}/auth${json}`;
      } else {
        setShowLogin(true);
      }
    } catch {
    } finally {
    }
  }

  const getValueAfterLogin = async (json: any, isFromSSO: boolean = false) => {
    if (json[0].SwitchAccountId > 0) {
      if (await callServices(json[0].AccessToken)) {
        setIsLoading(false);
      }
    } else {
      localStorage.setItem("showAttendanceBtn", json[0].IsTimeInOutAvailable);
      localStorage.setItem('accessToken', json[0].AccessToken);
      localStorage.setItem('accountEmployeeId', json[0].AccountEmployeeId);
      localStorage.setItem('isXeroConnected', json[0].IsXeroConnected.toString());
      localStorage.setItem('userEmailAddress', json[0].EMailAddress);
      localStorage.setItem('userRole', json[0].Role);
      const defaultPage = json[0].SystemCategoryPageFrontEnd;
      if (defaultPage && defaultPage !== 'null' && defaultPage !== 'undefined') {
        localStorage.setItem('systemCategoryPageFrontEnd', defaultPage);
      } else {
        localStorage.removeItem('systemCategoryPageFrontEnd');
      }
      localStorage.setItem('accountId', json[0].AccountId);
      localStorage.setItem('DefaultAccountPageId', json[0].DefaultAccountPageId);
      localStorage.setItem('IsLicenseExpired', json[0].IsLicenseExpired.toString());
      localStorage.setItem('IsLDAP', json[0].IsLDAP.toString());
      localStorage.setItem('user', JSON.stringify({
        tenantID: "t1",
        accountID: json[0].AccountId,
        userID: json[0].AccountEmployeeId,
        authToken: json[0].AccessToken
      }));
      if (isFromSSO == false) {
        localStorage.setItem('ma_rid', json[0].MasterAccountRoleId);
        localStorage.setItem('IsFreeLicenseExpired', json[0].IsFreeLicenseExpired.toString());
      }
      if (isFromSSO) {
        localStorage.setItem('redirectAfterLogin', "");
      }
      let object = {
        "id": 0,
        "first_name": "",
        "last_name": "",
        "email": "",
        "created_at": "2023-07-12T13:39:05.000000Z",
        "email_verified_at": "2023-07-12T13:39:05.000000Z",
        "updated_at": "2023-07-12T13:39:05.000000Z",
        "api_token": "",
        "AccountId": 0,
        "AccountEmployeeId": 0,
        "AccountRoleId": 0,
        "ProfilePictureColor": "",
        "EmployeeInitials": "",
        "EmployeeNameWithCode": "",
        "HoursPerDay": "",
        "UserInterfaceLanguage": "",
        "ProfileUrl":"",
      }
      json.map((item: any) => {
        object.id = item.AccountEmployeeId;
        object.first_name = item.FirstName;
        object.last_name = item.LastName;
        object.email = item.EMailAddress;
        object.api_token = item.AccessToken;
        object.AccountId = item.AccountId;
        object.AccountEmployeeId = item.AccountEmployeeId;
        object.AccountRoleId = item.AccountRoleId;
        object.ProfilePictureColor = item.ProfilePictureColor;
        object.EmployeeInitials = `${item.FirstName.toUpperCase().split('')[0]}${item.LastName.toUpperCase().split('')[0]}`;
        object.EmployeeNameWithCode = item.EmployeeNameWithCode;
        object.HoursPerDay = item.HoursPerDay;
        object.UserInterfaceLanguage = item.UserInterfaceLanguage;
        object.ProfileUrl =  item.ProfileUrl
      });
      saveAuth(object);
      let data = await getUserAuthentication(json[0].AccessToken, json[0].AccountEmployeeId);
      setCurrentUser(data);
      setErrorValues({
        ...errorValues,
        isShow: false,
        message: ""
      });
    }
  }

  const loginWithSaml = async (accountEmployeeId: Number) => {
    try {
      const response: any = await fetch(`${base_url}api/Account/TimeLiveLoginWithSaml/${accountEmployeeId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const json = await response.json();
      if (!json.hasOwnProperty('message')) {
        getValueAfterLogin(json, true);
        // if (json[0].SwitchAccountId > 0) {
        //   if (await callServices(json[0].AccessToken)) {
        //     setIsLoading(false);
        //   }
        // } else {
        //   localStorage.setItem('accessToken', json[0].AccessToken);
        //   localStorage.setItem('accountEmployeeId', json[0].AccountEmployeeId);
        //   localStorage.setItem('isXeroConnected', json[0].IsXeroConnected.toString());
        //   localStorage.setItem('userEmailAddress', json[0].EMailAddress);
        //   localStorage.setItem('userRole', json[0].Role);
        //   localStorage.setItem('accountId', json[0].AccountId);
        //   let object = {
        //     "id": 0,
        //     "first_name": "",
        //     "last_name": "",
        //     "email": "",
        //     "created_at": "2023-07-12T13:39:05.000000Z",
        //     "email_verified_at": "2023-07-12T13:39:05.000000Z",
        //     "updated_at": "2023-07-12T13:39:05.000000Z",
        //     "api_token": "",
        //     "AccountId": 0,
        //     "AccountEmployeeId": 0,
        //     "AccountRoleId": 0,
        //     "ProfilePictureColor": "",
        //     "EmployeeInitials": "",
        //     "EmployeeNameWithCode": "",
        //     "HoursPerDay": "",
        //     "UserInterfaceLanguage": ""
        //   }
        //   json.map((item: any) => {
        //     object.id = item.AccountEmployeeId;
        //     object.first_name = item.FirstName;
        //     object.last_name = item.LastName;
        //     object.email = item.EMailAddress;
        //     object.api_token = item.AccessToken;
        //     object.AccountId = item.AccountId;
        //     object.AccountEmployeeId = item.AccountEmployeeId;
        //     object.AccountRoleId = item.AccountRoleId;
        //     object.ProfilePictureColor = item.ProfilePictureColor;
        //     object.EmployeeInitials = `${item.FirstName.toUpperCase().split('')[0]}${item.LastName.toUpperCase().split('')[0]}`;
        //     object.EmployeeNameWithCode = item.EmployeeNameWithCode;
        //     object.HoursPerDay = item.HoursPerDay;
        //     object.UserInterfaceLanguage = item.UserInterfaceLanguage;
        //   });
        //   saveAuth(object);
        //   let data = await getUserAuthentication(json[0].AccessToken, json[0].AccountEmployeeId);
        //   setCurrentUser(data);
        //   setErrorValues({
        //     ...errorValues,
        //     isShow: false,
        //     message: ""
        //   });
        // }
      }
    }
    catch {

    }
  }

  const loginApplication = async (value: any) => {
    try {
      setIsLoading(true);
      //const response: any = await fetchAPI(`api/V2/Account/TimeLiveLogin/${encodeURIComponent(loginValues.emailAddress)}/${encodeURIComponent(loginValues.password)}`, "GET", "", true);
      //const response: any = await fetch(`${base_url}api/V2/Account/TimeLiveLogin/${encodeURIComponent(value.emailAddress)}/${encodeURIComponent(value.password)}/${true}`, {
      const response: any = await fetch(`${base_url}api/V2/Account/TimeLiveLogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          //'Authorization': "Basic " + toBase64(value.emailAddress + ":" + value.password),
          'Authorization': "Basic " + toBase64(value.emailAddress + ":" + encodeURIComponent(value.password)),
          'IsReactClient': 'true'
        },
        body: JSON.stringify({
          UserName: value.emailAddress,
          Password: value.password,
          IsReact: true
        })
      });
      const json = await response.json();
      if (!json.hasOwnProperty('message')) {
        getValueAfterLogin(json, false);
        // if (json[0].SwitchAccountId > 0) {
        //   if (await callServices(json[0].AccessToken)) {
        //     setIsLoading(false);
        //   }
        // } else {
        //   localStorage.setItem('accessToken', json[0].AccessToken);
        //   localStorage.setItem('accountEmployeeId', json[0].AccountEmployeeId);
        //   localStorage.setItem('isXeroConnected', json[0].IsXeroConnected.toString());
        //   localStorage.setItem('userEmailAddress', json[0].EMailAddress);
        //   localStorage.setItem('userRole', json[0].Role);
        //   localStorage.setItem('accountId', json[0].AccountId);
        //   let object = {
        //     "id": 0,
        //     "first_name": "",
        //     "last_name": "",
        //     "email": "",
        //     "created_at": "2023-07-12T13:39:05.000000Z",
        //     "email_verified_at": "2023-07-12T13:39:05.000000Z",
        //     "updated_at": "2023-07-12T13:39:05.000000Z",
        //     "api_token": "",
        //     "AccountId": 0,
        //     "AccountEmployeeId": 0,
        //     "AccountRoleId": 0,
        //     "ProfilePictureColor": "",
        //     "EmployeeInitials": "",
        //     "EmployeeNameWithCode": "",
        //     "HoursPerDay": "",
        //     "UserInterfaceLanguage": ""
        //   }
        //   json.map((item: any) => {
        //     object.id = item.AccountEmployeeId;
        //     object.first_name = item.FirstName;
        //     object.last_name = item.LastName;
        //     object.email = item.EMailAddress;
        //     object.api_token = item.AccessToken;
        //     object.AccountId = item.AccountId;
        //     object.AccountEmployeeId = item.AccountEmployeeId;
        //     object.AccountRoleId = item.AccountRoleId;
        //     object.ProfilePictureColor = item.ProfilePictureColor;
        //     object.EmployeeInitials = `${item.FirstName.toUpperCase().split('')[0]}${item.LastName.toUpperCase().split('')[0]}`;
        //     object.EmployeeNameWithCode = item.EmployeeNameWithCode;
        //     object.HoursPerDay = item.HoursPerDay;
        //     object.UserInterfaceLanguage = item.UserInterfaceLanguage;
        //   });
        //   saveAuth(object);
        //   let data = await getUserAuthentication(json[0].AccessToken, json[0].AccountEmployeeId);
        //   setCurrentUser(data);
        //   setErrorValues({
        //     ...errorValues,
        //     isShow: false,
        //     message: ""
        //   });
        // }
      } else {
        if (json.message === "IsForcePasswordChange") {
          navigate('/auth/changepassword', {
            state: {
              "isForcePasswordChange": true,
              "isPasswordExpired": false,
              "email": value.emailAddress
            }
          });
        } else if (json.message === "IsPasswordExpired") {
          navigate('/auth/changepassword', {
            state: {
              "isForcePasswordChange": false,
              "isPasswordExpired": true,
              "email": value.emailAddress
            }
          });
        } else if (json.message.includes("AccountId=")) {
          let response = json.message.split('&');
          navigate('/auth/multifactorverification', {
            state: {
              "AccountId": Number(response[0].replace("AccountId=", "")),
              "AccountEmployeeId": Number(response[1].replace("AccountEmployeeId=", "")),
              "Username": response[2].replace("Username=", ""),
              "isMFAAuthenticationList": true              
            }
          });
        } else {
          setErrorValues({
            ...errorValues,
            isShow: true,
            message: json.message
          });
        }
      }
    } catch (error) {
      setErrorValues({
        ...errorValues,
        isShow: true,
        message: "Your login attempt was not successful. Please try again."
      });
    } finally {
      setIsLoading(false);
    }
  }

  const handleBlurValidateAll = (setFieldTouched: any, values: any, validateForm: any) => {
    Object.keys(values).forEach(field => {
      setFieldTouched(field, true);
    });
    validateForm();
  }

  const handleSuccess = async (credentialResponse: any) => {
    setIsLoading(true);
    try {
      // "https://localdebug2.livetecs.com/api/Account/GoogleLogin"
      fetch(`${base_url}api/Account/GoogleLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ jwtToken: credentialResponse.credential })
      }).then((response) => response.json()).then(async (data) => {
        let json = data;
        if (!json.hasOwnProperty('message')) {
          getValueAfterLogin(json, true);
          // if (response[0].SwitchAccountId > 0) {
          //   if (await callServices(response[0].AccessToken)) {
          //     setIsLoading(false);
          //   }
          // } else {
          //   localStorage.setItem('accessToken', response[0].AccessToken);
          //   localStorage.setItem('accountEmployeeId', response[0].AccountEmployeeId);
          //   localStorage.setItem('isXeroConnected', response[0].IsXeroConnected.toString());
          //   localStorage.setItem('userEmailAddress', response[0].EMailAddress);
          //   localStorage.setItem('userRole', response[0].Role);
          //   localStorage.setItem('accountId', response[0].AccountId);
          //   let object = {
          //     "id": 0,
          //     "first_name": "",
          //     "last_name": "",
          //     "email": "",
          //     "created_at": "2023-07-12T13:39:05.000000Z",
          //     "email_verified_at": "2023-07-12T13:39:05.000000Z",
          //     "updated_at": "2023-07-12T13:39:05.000000Z",
          //     "api_token": "",
          //     "AccountId": 0,
          //     "AccountEmployeeId": 0,
          //     "AccountRoleId": 0,
          //     "ProfilePictureColor": "",
          //     "EmployeeInitials": "",
          //     "EmployeeNameWithCode": "",
          //     "HoursPerDay": "",
          //     "UserInterfaceLanguage": ""
          //   }
          //   response.map((item: any) => {
          //     object.id = item.AccountEmployeeId;
          //     object.first_name = item.FirstName;
          //     object.last_name = item.LastName;
          //     object.email = item.EMailAddress;
          //     object.api_token = item.AccessToken;
          //     object.AccountId = item.AccountId;
          //     object.AccountEmployeeId = item.AccountEmployeeId;
          //     object.AccountRoleId = item.AccountRoleId;
          //     object.ProfilePictureColor = item.ProfilePictureColor;
          //     object.EmployeeInitials = `${item.FirstName.toUpperCase().split('')[0]}${item.LastName.toUpperCase().split('')[0]}`;
          //     object.EmployeeNameWithCode = item.EmployeeNameWithCode;
          //     object.HoursPerDay = item.HoursPerDay;
          //     object.UserInterfaceLanguage = item.UserInterfaceLanguage;
          //   });
          //   saveAuth(object);
          //   let data = await getUserAuthentication(response[0].AccessToken, response[0].AccountEmployeeId);
          //   setCurrentUser(data);
          //   setErrorValues({
          //     ...errorValues,
          //     isShow: false,
          //     message: ""
          //   });
          // }
        } else {
          setErrorValues({
            ...errorValues,
            isShow: true,
            message: json.message
          });
          setIsLoading(false);
        }
      }).catch((error) => {
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleError = () => {
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  return (
    <>
      {isLoading && <Loader />}
      {isShowLogin && <div className="d-flex flex-column flex-root"
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
          width: '100%',
          position: 'relative'
          //backgroundColor: '#f2f6f8'
        }}
      >
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div
            //old
            //className="d-flex flex-lg-row-fluid"
            //new start
            className="d-flex flex-lg-row-fluid align-items-center justify-content-center"
            style={{
              padding: '20px', // Add padding for smaller resolutions
              flex: 1 // Ensure it stretches across the screen
            }}
          //new end
          // style={{
          //   backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/background.png')})`,
          //   backgroundPosition: 'center', backgroundRepeat: 'no-repeat'
          // }}
          >
            <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100"
              //new start
              style={{ maxWidth: '500px', textAlign: 'center' }}
            //new end
            >
              <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
              <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                Fast, Efficient and Productive
              </h1>
              <div className="color-TextDarkBlue fs-base text-center fw-semibold" style={{ width: '127%' }}>
                Discover the ultimate time tracking software designed to streamline your business operations.
                <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
              </div>
            </div>
          </div>
          <Formik
            initialValues={loginValues}
            enableReinitialize={true}
            onSubmit={values => { loginApplication(values) }}
            validationSchema={yup.object().shape({
              emailAddress: yup
              .string()
              .label('Email Address')
              .required('Email address is required'),
              // .test(
              //   'is-valid-email',
              //   'Invalid email address',
              //   value =>
              //     value
              //       ? /^[a-zA-Z0-9._%+&()\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
              //       : false
              // ),
              password: yup
                .string()
                .label('Password')
                .required()
            })}
          >
            {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
              <Fragment>
                <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12"
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      handleSubmit();
                    }
                  }}>
                  <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow"
                    //new start
                    style={{
                      maxHeight: '100%', // Ensure no overflow
                      overflow: 'hidden'
                    }}
                  //new end
                  >
                    <div
                      //old
                      className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-425px"
                    //new start
                    // className="d-flex flex-center flex-column align-items-stretch w-md-425px"
                    //new end
                    >
                      <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                        <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                          <div className="text-center mb-10">
                            <>
                              {/* <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')}
                                className='h-55px app-sidebar-logo-minimize mb-2'
                              /> */}
                              <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                                className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                              />
                            </>
                            {/* <h4 className="card-title fw-bold signTitle">
                              Sign In
                            </h4> */}
                            <div className="text-gray-500 fs-4">
                              {/* Log in to your account */}
                              Optimize your business operations with TimeLive
                            </div>
                          </div>
                          {errorValues.isShow &&
                            <div id="validationerror" className="alert alert-danger">
                              <strong>Error!</strong>
                              <ul>
                                <li>{errorValues.message}</li>
                              </ul>
                            </div>
                          }
                          <div className="fv-row mb-8 fv-plugins-icon-container mt-12">
                            <input
                              type="text"
                              placeholder="Email"
                              name="email"
                              value={values.emailAddress}
                              onChange={handleChange('emailAddress')}
                              className='form-control fs-6 fw-normal'
                              onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                            />
                            <div>
                              {touched.emailAddress && errors.emailAddress &&
                                <p className='errorMsg'>{errors.emailAddress as string}</p>
                              }
                            </div>
                          </div>
                          <div className="fv-row mb-3 fv-plugins-icon-container">
                            <div className="wrapper">
                              <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                name="password"
                                className="form-control fs-6 fw-normal"
                                value={values.password}
                                onChange={handleChange('password')}
                                onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                              />
                              <span
                                className="insideField-Icons form-label fs-6 fw-normal cursor"
                                onClick={togglePasswordVisibility}
                              >
                                {showPassword ? (
                                  <i className="bi bi-eye-slash-fill text-gray"></i>
                                ) : (
                                  <i className="bi bi-eye-fill text-gray"></i>
                                )}
                              </span>
                            </div>
                            <div>
                              {touched.password && errors.password && (
                                <p className="errorMsg">{errors.password as string}</p>
                              )}
                            </div>
                          </div>
                          <div className="d-flex flex-stack flex-wrap gap-3 fs-base mb-8">
                            <div>
                            </div>
                            <Link to='/auth/forgotpassword'>
                              <a className="text-primaryTL cursor">
                                {('Forgot your password?')}
                              </a>
                            </Link>
                          </div>
                          <div className="d-grid mb-4">
                            <button
                              type="button"
                              className="btn btn-primary btn-bs-btn-font-weight fs-6"
                              onClick={() => handleSubmit()}
                              disabled={!isValid}
                            >
                              {('Sign In')}
                            </button>
                          </div>
                          <div className="separator separator-content my-14" style={{ borderBottom: '2px solid black !important' }}>
                            <span className="w-200px text-gray-500 fs-6">{('Or continue with')}</span>
                          </div>
                          <div className="text-center">
                            {/* <a
                              className="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap"
                              style={{ paddingRight: 24 }}
                              onClick={() => handleGoogleLogin()}
                            >
                              <img alt="Logo"
                                src={toAbsoluteUrl('/media/svg/customSVG/Google.svg')}
                                className="h-15px me-3"
                              />
                              Sign in with Google
                            </a> */}
                            <GoogleOAuthProvider clientId="146606274956-poi42pods1u3969892i3eggasrju7glv.apps.googleusercontent.com">
                              <div>
                                <GoogleLogin
                                  onSuccess={handleSuccess}
                                  onError={handleError}
                                />
                              </div>
                            </GoogleOAuthProvider>
                          </div>
                          <div className="text-gray-500 text-center fs-6 mt-8">
                            Don't have a Timelive account yet?
                            <Link to='/auth/registration'>
                              <a className="text-primaryTL cursor ms-1">
                                {('Sign up')}
                              </a>
                            </Link>
                            {/* <a href="https://timelive.livetecs.com/Home/AccountAdd.aspx" className="text-primaryTL cursor ms-1">
                              {('Sign up')}
                            </a> */}
                          </div>
                        </div>
                      </div>
                      <div className=" d-flex flex-stack">
                        <div className="text-gray-500 text-center fs-6 mt-8">
                          By clicking Sign In button, I agree to Livetecs
                          <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Terms Of Use')}
                          </a> and <a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Privacy Policy')}
                          </a>
                        </div>
                      </div>
                      {/* <div className=" d-flex flex-stack">
                        <div className="text-gray-500 text-center fs-6 mt-8">
                          Explore our
                          <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Terms')}
                          </a>, check out our <a href="https://www.livetecs.com/on-demand-price/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Plans')}
                          </a>, or feel free to <a href="https://www.livetecs.com/contact-us/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Contact us')}
                          </a> for more information.
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </Formik>
        </div>
      </div>}
    </>
  )
}

const toBase64 = (str: string) => {
  return window.btoa(unescape(encodeURIComponent(str)));
}